<template>
  <ul class="pagination">
    <li>
      <button
        class="pagination-previous"
        :class="{ invisible: modelValue === 1 }"
        :aria-hidden="modelValue === 1"
        :aria-label="`Go back to page ${modelValue} of ${totalPages}`"
        @click="handlePaginationBackClick"
      />
    </li>
    <li class="select-container">
      <Form>
        <Dropdown
          v-model="currentPage"
          :options="options"
          label="Page"
          name="reviews-pagination"
        />
      </Form>
    </li>
    <li>
      <button
        class="pagination-next"
        :class="{ invisible: modelValue === totalPages }"
        :aria-hidden="modelValue === totalPages"
        :aria-label="`Go forward to page ${modelValue + 1} of ${totalPages}`"
        @click="handlePaginationNextClick"
      />
    </li>
  </ul>
</template>

<script setup>
import Form from '@atomic-ui/form';
import Dropdown from '@atomic-ui/dropdown';
import { computed } from 'vue';

const props = defineProps({
  options: {
    required: true,
    type: Array,
  },
  totalPages: {
    required: true,
    type: Number,
  },
  modelValue: {
    required: true,
    type: Number,
  },
});

const updateEvent = 'update:modelValue';
const emit = defineEmits(['update:modelValue']);

const currentPage = computed({
  get() {
    return String(props.modelValue);
  },
  set(val) {
    emit(updateEvent, parseInt(val, 10));
  },
});

const handlePaginationNextClick = () => {
  emit(updateEvent, parseInt(currentPage.value, 10) + 1);
};

const handlePaginationBackClick = () => {
  emit(updateEvent, parseInt(currentPage.value, 10) - 1);
};
</script>

<style lang="scss" scoped>
@import "@core/csg/src/scss/forms/forms.scss";
@import "@core/csg/src/scss/components/pagination";

@include csg-form-label;
@include csg-form-select;
@include csg-pagination;

.pagination {
  justify-content: center;
}

@include breakpoint(large) {
  .pagination {
    justify-content: flex-end;
  }
}

button:hover {
  cursor: pointer;
}
</style>
